<script>
export default {
  TencentAPPID: "2018946756"
}
</script>
